import { ComponentProps } from 'react';

import classNames from 'classnames';

import { Text } from '@spotify-internal/encore-web';

import { asDialogSlot } from './composition';

import styles from './Subtitle.module.css';

export type SubtitleProps = Omit<ComponentProps<typeof Text>, 'as'>;

export const Subtitle = ({
  children,
  className,
  variant = 'bodySmall',
  semanticColor = 'textSubdued',
  ...rest
}: SubtitleProps) => {
  return (
    <Text
      as="div"
      variant={variant}
      semanticColor={semanticColor}
      className={classNames(styles.root, className)}
      {...rest}
    >
      {children}
    </Text>
  );
};

Subtitle.displayName = 'DialogComposite.Subtitle';

asDialogSlot(Subtitle, 'subtitle');

export default Subtitle;
